import { render, staticRenderFns } from "./modify_account.vue?vue&type=template&id=a7432518&scoped=true"
import script from "./modify_account.vue?vue&type=script&lang=ts"
export * from "./modify_account.vue?vue&type=script&lang=ts"
import style0 from "./modify_account.vue?vue&type=style&index=0&id=a7432518&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7432518",
  null
  
)

export default component.exports